import { render } from "./WebHosting.vue?vue&type=template&id=856bc00a"
import script from "./WebHosting.vue?vue&type=script&lang=js"
export * from "./WebHosting.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__